
<div id="customizer-form">
    @for(layout of response$()?.mainLayout; let index = $index; track index) {
        <input type="text"
               [name]="index == 0 ? 'group' : 'line'"
               [id]="layout.productId"
               [attr.value]="layout.variation"
               hidden>
        <ul class="options">
            @for(variant of layout.variatants; track $index) {
                <li class="option">
                    <span class="option-title">{{ variant.type }}</span>
                    <span class="option-name">{{ variant.option }}</span>
                </li>
            }
        </ul>
        <button type="button"
                class="overview"
                (click)="openView(layout)">
            <app-svg use="customizer-icon"></app-svg>
            <span>{{ 'CUSTOMIZER.OPEN_FROM_OVERVIEW' | translate }}</span>
        </button>
    }
</div>

<app-customizer-dialog [id]="uuid" ></app-customizer-dialog>
